module.exports = __webpack_public_path__ + "static/media/vip-profiler-jd.5a993fdc.svg";